// Module
var code = "<div id=invite-collaborators-modal><h2>Add Collaborators</h2><h4>Individuals</h4><user-connections ng-if=!$ctrl.loading doc=$ctrl.lead add-user=\"$ctrl.inviteUser({ user })\" is-added-client=\"$ctrl.isOnLead({ user })\" user=$ctrl.user connected-users=$ctrl.filteredClients></user-connections></div>";
// Exports
module.exports = code;